import { BackgroundEntityContainer } from "@client/controls/Style/Background/container";
import withIsVisibleHOC from "@client/hocs/withIsVisible";
import { getEntityDataAttributes } from "@client/lib/entities";
import { type Context, type EntityRef, EntityType } from "@client/types";
import classNames from "classnames";
import * as React from "react";
import { getEntityClassName } from "./lib";

import "./style.less";

export type MapProps = EntityRef &
  React.HTMLProps<HTMLDivElement> & {
    children?: any;
    context: Context;
    type: EntityType;
    viewonly?: boolean;
  };

const Entity = ({ source, children, context, id, type, viewonly, ...props }: MapProps) => {
  const style = React.useMemo((): React.CSSProperties | undefined => {
    if (!props.style) return;

    switch (type) {
      case EntityType.Column: {
        const { minHeight, ...style } = props.style;
        if (!minHeight || !minHeight.toString().endsWith("%")) return props.style;

        const mh = parseFloat(minHeight.toString());
        if (!mh) return props.style;

        return {
          ...style,
          aspectRatio: 1 / (mh / 100)
        };
      }
    }
    return props.style;
  }, [props.style, type]);

  return (
    <div
      {...props}
      {...getEntityDataAttributes(id, viewonly)}
      className={classNames(props.className, getEntityClassName(type))}
      style={style}
    >
      <BackgroundEntityContainer id={id} source={source} />

      {children}
    </div>
  );
};
export default withIsVisibleHOC<MapProps>(Entity);
